export default __webpack_public_path__ + "static/media/compare__item-icon-1.ff5dd759.svg";